import styles from './styles.module.css';

type AppMessageType = {
  Message?: string;
  backgroundColor?: string;
  type?: string;
};

const AppMessage = ({
  Message,
  backgroundColor = 'inputError',
  type = 'error',
}: AppMessageType) => {
  return (
    <div className={Message ? styles.server_message_on : styles.server_message_under}>
      <div
        // style={{
        //   backgroundColor: backgroundColor,
        // }}
        className={`${Message ? styles.server_message_child_show : styles.server_message_child_hide}`}
        style={{
          backgroundColor: type == 'error' ? 'var(--accent)' : 'var(--green)',
        }}
      >
        <p
          className={`${Message ? styles.server_message_child_para_show : styles.server_message_child_para_hide} ${styles.text}`}
        >
          {Message}
        </p>
      </div>
    </div>
  );
};

export default AppMessage;
